export default "__VITE_ASSET__BaiO8fS5__"